export default __webpack_public_path__ + "static/media/480_private03-it-mobile.36b79fd5.png";